import axios from "axios";
import {
  GET_ALL_MEMBERS,
  GET_ALL_NEW_MEMBERS,
  GET_DOWNLOAD,
  GET_ALL_MEMBERS_details,
} from "./types";
const keys = require("../config/keys");

export const getAllMembers = (data) => async (dispatch) => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/member/getallmembers",
    data: data,
  })
    .then((res) => {
      if (res.data) {
        try {
          dispatch({ type: GET_ALL_MEMBERS, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch((e) => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const insertMembers = (data) => async (dispatch) => {
  await axios({
    method: "post",
    url: keys.ServicePath + "/api/member/insert",
    data: data,
  })
    .then((res) => {
      if (res.data) {
        try {
          dispatch({ type: GET_ALL_MEMBERS, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch((e) => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const insertNewMembers = (data) => async (dispatch) => {
  await axios({
    method: "post",
    url: keys.ServicePath + "/api/member/insertNewMember",
    data: data,
  })
    .then((res) => {
      if (res.data) {
        try {
          dispatch({ type: GET_ALL_MEMBERS, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch((e) => {
      console.log("catch error", JSON.stringify(e));
    });
};

//renewalMember

// export const insertMemberrenewal = (data) => async (dispatch) => {
//   await axios({
//     method: "post",
//     url: keys.ServicePath + "/api/member/insertMemberrenewal",
//     data: data,
//   })
//     .then((res) => {
//       if (res.data) {
//         try {
//           dispatch({ type: GET_ALL_MEMBERS, payload: res.data.data });
//         } catch (exc) {
//           console.log("exception", exc);
//         }
//       }
//     })
//     .catch((e) => {
//       console.log("catch error", JSON.stringify(e));
//     });
// };

export const getNewMembers = (startDate, endDate, data) => async (dispatch) => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/member/get_new_members?startDate=" +
      startDate +
      "&endDate=" +
      endDate,
    data: data,
  })
    .then((res) => {
      if (res.data) {
        try {
          dispatch({ type: GET_ALL_NEW_MEMBERS, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch((e) => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const download = (startdate, enddate) => async (dispatch) => {
  await axios({
    method: "get",

    url: ` ${keys.ServicePath}/api/payment/download?startdate=${startdate}&enddate=${enddate}`,
  })
    .then((res) => {
      if (res.data) {
        try {
          dispatch({ type: GET_DOWNLOAD, payload: res.data });
          console.log(res.data);
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch((e) => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getAllMemberDetails = (code) => async (dispatch) => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/member/getdetails?code=" + code,
    // data: data,
  })
    .then((res) => {
      if (res.data) {
        try {
          dispatch({ type: GET_ALL_MEMBERS_details, payload: res.data.data });
          console.log("payload", res.data.data);
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch((e) => {
      console.log("catch error", JSON.stringify(e));
    });
};
